import { createStyles } from '@mantine/styles';

export default createStyles(() => ({
  overlay: {},
}));
